import ConferencePage from "../components/conferences/main";

const Conference = () => {
  return <ConferencePage />;
};

export default Conference;
